/*
 * Grade de coleção / busca OUTLET034 — filtros e ordenação nativos sem reload.
 * Markup: snippets/collection-toolbar-034.liquid (+ seções collection-grid-034
 * e search-results-034).
 *
 * - Filtros/ordenação via Section Rendering API (?section_id=). A resposta NÃO
 *   substitui o formulário inteiro: só a área de resultados ([data-cg034-results])
 *   é trocada; no formulário são atualizados apenas estados (checked, disabled,
 *   contagens, badges). Assim o drawer mobile mantém rolagem e foco, e os
 *   dropdowns do desktop não ficam "presos" abertos.
 * - Desktop: só um dropdown <details> aberto por vez; fecha ao clicar fora/Esc.
 * - Chips de filtros ativos e "Limpar tudo" navegam sem reload.
 * - "Carregar mais" (append) com fallback para a paginação padrão.
 * - Seletor de colunas 2/3/4: o padrão é o do lojista; a escolha do cliente só
 *   é salva quando ele clica (e vale enquanto o padrão do lojista não mudar).
 * - Drawer mobile: focus-trap, Esc fecha, aria-expanded, foco volta ao botão.
 * - Após cada re-render dispara `wishlist:hydrate` (corações).
 */
(function () {
  var COLS_KEY = 'outlet034:cols';
  var DESKTOP = window.matchMedia('(min-width: 750px)');

  function initAll() {
    var roots = document.querySelectorAll('[data-cg034]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__cg034) init(roots[i]);
    }
  }

  function init(root) {
    root.__cg034 = true;
    root.classList.add('cg034--js');
    applyColumns(root);

    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cg034-open]');
      if (openBtn) {
        openDrawer(root, openBtn);
        return;
      }
      if (e.target.closest('[data-cg034-close]')) {
        closeDrawer(root);
        return;
      }
      var colBtn = e.target.closest('[data-cg034-col]');
      if (colBtn) {
        setColumns(root, colBtn.getAttribute('data-cg034-col'));
        return;
      }
      var loadBtn = e.target.closest('[data-cg034-loadmore]');
      if (loadBtn) {
        e.preventDefault();
        loadMore(root, loadBtn);
        return;
      }
      var chip = e.target.closest('[data-cg034-chip]');
      if (chip) {
        e.preventDefault();
        fetchInto(root, chip.getAttribute('href'));
      }
    });

    // Desktop: um dropdown por vez.
    root.addEventListener(
      'toggle',
      function (e) {
        var d = e.target;
        if (!d.matches || !d.matches('.cg034__filter') || !d.open) return;
        if (!DESKTOP.matches) return;
        closeDropdowns(root, d);
      },
      true
    );

    // Clique fora fecha dropdowns (desktop).
    document.addEventListener('click', function (e) {
      if (!DESKTOP.matches) return;
      var inside = e.target.closest && e.target.closest('.cg034__filter');
      if (inside && root.contains(inside)) return;
      closeDropdowns(root);
    });

    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-cg034-form]')) return;
      applyFilters(root);
    });

    root.addEventListener('submit', function (e) {
      if (e.target.closest('[data-cg034-form]')) {
        e.preventDefault();
        applyFilters(root);
      }
    });

    root.addEventListener('keydown', function (e) {
      if (root.classList.contains('cg034--drawer-open')) {
        if (e.key === 'Escape') {
          closeDrawer(root);
          return;
        }
        if (e.key === 'Tab') trapTab(root, e);
        return;
      }
      if (e.key === 'Escape') {
        var open = root.querySelector('.cg034__filter[open]');
        if (open) {
          open.open = false;
          var summary = open.querySelector('summary');
          if (summary) summary.focus();
        }
      }
    });

    // Mudou de mobile <-> desktop com o drawer aberto: fecha e limpa estados.
    var onMq = function () {
      if (root.classList.contains('cg034--drawer-open')) closeDrawer(root, true);
      closeDropdowns(root);
    };
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onMq);
    else if (DESKTOP.addListener) DESKTOP.addListener(onMq);
  }

  function closeDropdowns(root, except) {
    var open = root.querySelectorAll('.cg034__filter[open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].open = false;
    }
  }

  /* ---------------- Colunas ---------------- */
  function readCols(root) {
    var def = root.getAttribute('data-cols-default');
    try {
      var saved = JSON.parse(window.localStorage.getItem(COLS_KEY) || 'null');
      if (saved && saved.n && String(saved.d) === String(def)) return String(saved.n);
    } catch (err) {
      /* ignora */
    }
    return null;
  }

  function setColumns(root, n) {
    try {
      window.localStorage.setItem(
        COLS_KEY,
        JSON.stringify({ n: String(n), d: root.getAttribute('data-cols-default') })
      );
    } catch (err) {
      /* ignora */
    }
    applyColumns(root);
  }

  function applyColumns(root) {
    var chosen = readCols(root);
    var def = root.getAttribute('data-cols-default');
    if (chosen) root.style.setProperty('--cg034-cols-d', chosen);
    else root.style.setProperty('--cg034-cols-d', def);
    var effective = chosen || def;
    var btns = root.querySelectorAll('[data-cg034-col]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute(
        'aria-pressed',
        btns[i].getAttribute('data-cg034-col') === String(effective) ? 'true' : 'false'
      );
    }
  }

  /* ---------------- Filtros (Section Rendering) ---------------- */
  // "1.234,56" -> "1234.56"
  function normalizePrice(v) {
    if (v == null) return '';
    var s = String(v).trim().replace(/[^\d.,]/g, '');
    if (!s) return '';
    if (s.indexOf(',') > -1 && s.indexOf('.') > -1) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (s.indexOf(',') > -1) {
      s = s.replace(',', '.');
    }
    return s;
  }

  function buildUrl(root) {
    var form = root.querySelector('[data-cg034-form]');
    var base = root.getAttribute('data-collection-url');
    if (!form) return base;
    var params = new URLSearchParams(new FormData(form));
    var clean = new URLSearchParams();
    params.forEach(function (value, key) {
      var val = value;
      if (key.indexOf('filter.v.price.') === 0) val = normalizePrice(val);
      if (val !== '' && val != null) clean.append(key, val);
    });
    var qs = clean.toString();
    return qs ? base + '?' + qs : base;
  }

  var debounceTimer;
  function applyFilters(root) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetchInto(root, buildUrl(root));
    }, 150);
  }

  function withSection(url, sectionId) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
  }

  var controller;
  function fetchInto(root, url) {
    var sectionId = root.getAttribute('data-section-id');
    var content = root.querySelector('[data-cg034-content]');
    if (content) content.setAttribute('aria-busy', 'true');

    if (controller && controller.abort) controller.abort();
    controller = window.AbortController ? new AbortController() : null;

    fetch(withSection(url, sectionId), controller ? { signal: controller.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        update(root, doc);
        try {
          window.history.replaceState({ cg034: true }, '', url);
        } catch (err) {
          /* ignora */
        }
        afterRender(root);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.assign(url);
      });
  }

  function update(root, doc) {
    var cur = root.querySelector('[data-cg034-content]');
    var next = doc.querySelector('[data-cg034-content]');
    if (!cur || !next) return;

    var curForm = cur.querySelector('[data-cg034-form]');
    var nextForm = next.querySelector('[data-cg034-form]');
    var curResults = cur.querySelector('[data-cg034-results]');
    var nextResults = next.querySelector('[data-cg034-results]');

    // Estrutura mudou (ex.: barra apareceu/sumiu)? troca tudo, sem drawer aberto.
    if (!curResults || !nextResults || !curForm !== !nextForm || !sameFilters(curForm, nextForm)) {
      var wasOpen = root.classList.contains('cg034--drawer-open');
      if (wasOpen) closeDrawer(root, true);
      cur.innerHTML = next.innerHTML;
      return;
    }

    curResults.innerHTML = nextResults.innerHTML;
    if (curForm && nextForm) patchForm(curForm, nextForm);
  }

  function filterKeys(form) {
    if (!form) return '';
    var list = form.querySelectorAll('[data-cg034-filter]');
    var keys = [];
    for (var i = 0; i < list.length; i++) {
      keys.push(list[i].getAttribute('data-cg034-filter') + ':' + list[i].querySelectorAll('input').length);
    }
    return keys.join('|');
  }

  function sameFilters(a, b) {
    return filterKeys(a) === filterKeys(b);
  }

  function inputKey(input) {
    return input.name + '=' + (input.type === 'checkbox' ? input.value : '');
  }

  function patchForm(curForm, nextForm) {
    var map = {};
    var nextInputs = nextForm.querySelectorAll('input, select');
    for (var i = 0; i < nextInputs.length; i++) map[inputKey(nextInputs[i])] = nextInputs[i];

    var curInputs = curForm.querySelectorAll('input, select');
    for (var j = 0; j < curInputs.length; j++) {
      var el = curInputs[j];
      var src = map[inputKey(el)];
      if (!src) continue;
      if (el.type === 'checkbox') {
        el.checked = src.checked;
        el.disabled = src.disabled;
        var cnt = el.parentNode.querySelector('[data-cg034-vcount]');
        var srcCnt = src.parentNode.querySelector('[data-cg034-vcount]');
        if (cnt && srcCnt) cnt.textContent = srcCnt.textContent;
      } else if (el.tagName === 'SELECT') {
        el.value = src.value;
      } else if (el.type !== 'hidden' && el !== document.activeElement) {
        el.value = src.value;
      }
    }

    // Badges por filtro + total + contagem do "Ver resultados".
    var curFilters = curForm.querySelectorAll('[data-cg034-filter]');
    var nextFilters = nextForm.querySelectorAll('[data-cg034-filter]');
    for (var k = 0; k < curFilters.length; k++) {
      var nf = nextFilters[k];
      if (!nf) continue;
      curFilters[k].setAttribute('data-active', nf.getAttribute('data-active'));
      copyBadge(curFilters[k].querySelector('[data-cg034-fcount]'), nf.querySelector('[data-cg034-fcount]'));
    }
    copyBadge(curForm.querySelector('[data-cg034-active-count]'), nextForm.querySelector('[data-cg034-active-count]'));
    copyBadge(curForm.querySelector('[data-cg034-apply-count]'), nextForm.querySelector('[data-cg034-apply-count]'));
    var curClear = curForm.querySelector('.cg034__drawer-clear');
    var nextClear = nextForm.querySelector('.cg034__drawer-clear');
    if (curClear && nextClear) curClear.setAttribute('href', nextClear.getAttribute('href'));
  }

  function copyBadge(a, b) {
    if (!a || !b) return;
    a.textContent = b.textContent;
    a.hidden = b.hidden;
  }

  function afterRender(root) {
    var content = root.querySelector('[data-cg034-content]');
    if (content) content.removeAttribute('aria-busy');
    applyColumns(root);
    document.dispatchEvent(new CustomEvent('wishlist:hydrate'));
  }

  /* ---------------- Carregar mais ---------------- */
  function loadMore(root, btn) {
    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;
    btn.setAttribute('aria-busy', 'true');

    fetch(withSection(nextUrl, root.getAttribute('data-section-id')))
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-cg034-grid]');
        var curGrid = root.querySelector('[data-cg034-grid]');
        var firstNew = null;
        if (newGrid && curGrid) {
          while (newGrid.firstElementChild) {
            var li = newGrid.firstElementChild;
            if (!firstNew) firstNew = li;
            curGrid.appendChild(li);
          }
        }
        var newBtn = doc.querySelector('[data-cg034-loadmore]');
        if (newBtn) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          btn.removeAttribute('aria-busy');
        } else if (btn.parentNode) {
          btn.parentNode.removeChild(btn);
        }
        // Acessibilidade: leva o foco ao primeiro produto novo.
        if (firstNew) {
          var link = firstNew.querySelector('.pc034__name, a[href]');
          if (link) link.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('wishlist:hydrate'));
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        window.location.assign(nextUrl);
      });
  }

  /* ---------------- Drawer ---------------- */
  function panel(root) {
    return root.querySelector('.cg034__filters');
  }

  function openDrawer(root, opener) {
    var p = panel(root);
    if (!p) return;
    root.__opener = opener;
    root.classList.add('cg034--drawer-open');
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-modal', 'true');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    // Acordeões com filtro ativo começam abertos.
    var list = p.querySelectorAll('.cg034__filter');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-active') !== '0') list[i].open = true;
    }
    var close = p.querySelector('.cg034__drawer-close');
    if (close) close.focus();
  }

  function closeDrawer(root, silent) {
    var p = panel(root);
    root.classList.remove('cg034--drawer-open');
    if (p) {
      p.removeAttribute('role');
      p.removeAttribute('aria-modal');
    }
    document.documentElement.style.overflow = '';
    var opener = root.__opener || root.querySelector('[data-cg034-open]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (!silent && opener.isConnected) opener.focus();
    }
  }

  function focusable(container) {
    if (!container) return [];
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
  }

  function trapTab(root, e) {
    var els = focusable(panel(root));
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
